<template>
    <div class="relative dropdown" tabindex="0">
        <label @click="$emit('setSideBar', true, $event)"
            class="group w-12 h-12 flex items-center justify-center rounded-full bg-gray-210 dark:bg-base-200 hover:bg-biscay-700 transition relative cursor-pointer">
            <div class="w-12 h-12 bg-gray-300 rounded-full overflow-hidden border-2 border-solid border-gray-80">
                <img :src="user.image" class="w-full" height="40" alt="user-avatar">
            </div>
        </label>

        <div class="menu menu-compact dropdown-content sm:w-80 w-276 dark:!bg-base-300 dark:shadow-whiteShadow bg-white rounded-lg overflow-hidden top-16 -left-4 z-10"
            tabindex="0">
            <div>
                <div class="pt-7 px-5">
                    <div class="relative">
                        <span
                            class="absolute bg-biscay-100 dark:bg-white dark:bg-opacity-10 w-px md:h-full right-22px z-negative"></span>
                        <div class="flex items-start mb-4">
                            <div class="relative hvr-ripple-out">
                                <div
                                    class="w-12 h-12 ml-4 bg-gray-300 group relative rounded-full overflow-hidden border-2 border-solid border-green-700">
                                    <a>
                                        <img class="transition duration-200 transform group-hover:scale-110 w-full h-full"
                                            :src="user.image" alt="user-avatar">
                                        <div class="w-full h-full absolute top-0 right-0 bg-biscay-700 bg-opacity-20 z-0">
                                        </div>
                                    </a>
                                </div>
                            </div>
                            <div class="flex flex-col">
                                <a
                                    class="mb-2 dark:text-white text-biscay-500 hover:text-biscay-650 duration-200 transition font-bold text-xl">{{
                                        user.name
                                    }}</a>
                                <router-link :to="{ name: 'user.home' }"
                                    class="flex items-center font-medium text-base dark:text-blue-450 text-blue-700 hover:opacity-80">
                                    {{ __('View the user panel') }}
                                    <svg class="mr-2" width="15" height="10" viewBox="0 0 15 10" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M4.99998 0.833344L0.833313 5.00001M0.833313 5.00001H14.1666M0.833313 5.00001L4.99998 9.16668"
                                            stroke="#3B82F6" stroke-width="1.28571" stroke-linecap="round"
                                            stroke-linejoin="round">
                                        </path>
                                    </svg>
                                </router-link>
                            </div>
                        </div>
                        <div class="pr-12">
                            <div class="relative flex items-center justify-between mb-3">
                                <span class="w-4 h-4 absolute rounded-full bg-green-700 -right-34px"></span>
                                <div>
                                    <span class="dark:text-gray-100 text-gray-300 font-bold text-sm">{{
                                        __('wallet')
                                    }}</span>
                                </div>
                                <div>
                                    <span class="flex items-center dark:text-gray-100 text-gray-300 font-bold text-sm">
                                        {{ user.credit?.toLocaleString() }}
                                        <div class="mr-1 text-biscay-650 dark:text-gray-200 text-xs">
                                            {{ __('Toman') }}
                                        </div>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <hr class="dark:border-gray-360 dark:border-opacity-10 border-biscay-100 mt-5 mb-3">
                <ul class="pb-7 px-5">

                    <li class="hover:bg-dark-550 hover:bg-opacity-10 rounded-lg">
                        <router-link :to="{ name: 'user.profile' }" class="flex items-center py-3 px-4 cursor-pointer">
                            <div class="flex items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" class="dark:text-gray-920 text-gray-550 ml-4"
                                    width="21" height="21" fill="none" viewBox="0 0 24 24" stroke-width="1.7"
                                    stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
                                </svg>

                                <span class="dark:text-gray-920 text-gray-550 font-normal text-lg">{{
                                    __('Account Information')
                                }}</span>
                            </div>
                        </router-link>
                    </li>
                    <li class="dark:hover:bg-dark-450 hover:bg-dark-550 hover:bg-opacity-10 rounded-lg">
                        <router-link :to="{ name: 'user.payment.log' }" class="flex items-center justify-between py-3 px-4">
                            <div class="flex items-center">
                                <svg class="dark:text-gray-920 text-gray-550 ml-4" width="21" height="21"
                                    viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M18.4382 12.2664H14.9887C13.7221 12.2656 12.6955 11.2398 12.6947 9.9732C12.6947 8.70663 13.7221 7.68079 14.9887 7.68001H18.4382"
                                        stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round"></path>
                                    <path d="M15.3789 9.92071H15.1133" stroke="currentColor" stroke-width="1.5"
                                        stroke-linecap="round" stroke-linejoin="round"></path>
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M6.60165 2.55625H13.9666C16.436 2.55625 18.438 4.55823 18.438 7.0277V13.1431C18.438 15.6126 16.436 17.6146 13.9666 17.6146H6.60165C4.13218 17.6146 2.1302 15.6126 2.1302 13.1431V7.0277C2.1302 4.55823 4.13218 2.55625 6.60165 2.55625Z"
                                        stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round"></path>
                                    <path d="M5.99492 6.42315H10.5953" stroke="currentColor" stroke-width="1.5"
                                        stroke-linecap="round" stroke-linejoin="round"></path>
                                </svg>
                                <span class="dark:text-gray-920 text-gray-550 font-normal text-lg">{{
                                    __('Transactions')
                                }}</span>
                            </div>
                        </router-link>
                    </li>
                    <li class="hover:bg-dark-550 hover:bg-opacity-10 rounded-lg">
                        <router-link :to="{ name: 'user.notification' }"
                            class="flex items-center justify-between py-3 px-4 cursor-pointer">
                            <div class="flex items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                                    stroke="currentColor" width="21" height="21"
                                    class="dark:text-gray-920 text-gray-550 ml-4">
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0" />
                                </svg>


                                <span class="dark:text-gray-920 text-gray-550 font-normal text-lg">{{
                                    __('Notifications')
                                }}</span>
                            </div>
                            <span
                                class="rounded-full w-6 h-6  bg-yellow-500 flex justify-center text-white font-normal text-lg"
                                v-if="user.notification_count">{{ user.notification_count }}</span>
                        </router-link>
                    </li>
                    <li class="dark:hover:bg-dark-450 hover:bg-dark-550 hover:bg-opacity-10 rounded-lg">
                        <router-link :to="{ name: 'user.cards' }" class="flex items-center py-3 px-4">
                            <div class="flex items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" class="dark:text-gray-920 text-gray-550 ml-4"
                                    width="21" height="21" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                                    stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="M20.25 6.375c0 2.278-3.694 4.125-8.25 4.125S3.75 8.653 3.75 6.375m16.5 0c0-2.278-3.694-4.125-8.25-4.125S3.75 4.097 3.75 6.375m16.5 0v11.25c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125V6.375m16.5 0v3.75m-16.5-3.75v3.75m16.5 0v3.75C20.25 16.153 16.556 18 12 18s-8.25-1.847-8.25-4.125v-3.75m16.5 0c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125" />
                                </svg>

                                <span class="dark:text-gray-920 text-gray-550 font-normal text-lg">{{
                                    __('Cards')
                                }}</span>
                            </div>
                        </router-link>
                    </li>
                    <li class="hover:bg-dark-550 hover:bg-opacity-10 rounded-lg">
                        <label class="flex items-center py-3 px-4 cursor-pointer" for="logout"
                            @click="$emit('setSideBar', false)">
                            <div class="flex items-center">
                                <svg class="dark:text-gray-920 text-gray-550 ml-4" width="21" height="21"
                                    viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M12.7949 6.70662V5.91163C12.7949 4.17764 11.3889 2.7717 9.65495 2.7717H5.50104C3.76791 2.7717 2.36197 4.17764 2.36197 5.91163V15.3953C2.36197 17.1293 3.76791 18.5352 5.50104 18.5352H9.66347C11.3923 18.5352 12.7949 17.1336 12.7949 15.4047V14.6012"
                                        stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round"></path>
                                    <path d="M18.5835 10.6534H8.32356" stroke="currentColor" stroke-width="1.5"
                                        stroke-linecap="round" stroke-linejoin="round"></path>
                                    <path d="M16.0883 8.16948L18.5833 10.6533L16.0883 13.138" stroke="currentColor"
                                        stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                </svg>
                                <span class="dark:text-gray-920 text-gray-550 font-normal text-lg">{{
                                    __('Sign out of the user account')
                                }}</span>
                            </div>
                        </label>
                    </li>
                </ul>
            </div>
        </div>
</div></template>
<script setup>
defineEmits(['setSideBar']);
defineProps(['user']);
</script>